<template>
  <div>
    <b-container
      v-if="isLoaded"
      fluid
      class="px-0"
    >
      <b-row class="mb-2 px-1">
        <div class="d-flex w-100 align-items-start flex-wrap">
          <div class="align-self-start d-flex flex-row">
            <div class="header-right-label d-flex align-items-center mr-2">
              <b-card-title
                v-if="order.shipmentSeqId"
                class="m-0"
              >
                Shipment ID: {{ order.shipmentSeqId }}
              </b-card-title>
              <b-card-title
                v-else
                class="m-0"
              >
                Order ID: {{ order.orderSeqId }}
              </b-card-title>
            </div>
            <div class="header-left-actions d-flex">
              <split-action-button
                v-if="!isShipment"
                label="Download Order"
                :icon="DownloadCloudIcon"
                :disable-button="!canShowDownloadOrderButton"
                hide-dropdown-options
                @click="openDownloadModal"
              />
              <!-- Import/Export for shipment creation -->
              <b-button
                v-if="shipmentOrder && !order.shipmentId"
                variant="outline-info"
                @click="$emit('open-import-export')"
              >
                Import/Export
              </b-button>
              <shipment-action
                v-if="isShipment && (!shipmentOrder || shipmentOrder.shipmentId)"
                :shipment="order"
                @load-shipment="$emit('load-shipment')"
              />
              <order-upload-invoice
                v-if="
                  hasOrderConfirmed && !order.isModifyEnabledBrand && isBrand
                "
                class="ml-1"
                :order="order"
                :load-order="loadOrder"
              />
              <b-button
                v-if="canShowBackToReceivedButton"
                variant="info"
                class="ml-1"
                :disabled="isRevertingOrder"
                @click="handleRevertToAccepted"
              >
                {{ isRevertingOrder ? 'Loading...' : 'Back to Received' }}
              </b-button>
            </div>
          </div>
          <div class="ml-auto d-flex align-items-center">
            <duplicate-order-button
              v-if="!shipmentOrder && !order.shipmentId && !isShipment && hasDuplicateOrderFeature"
              :order="order"
              class="mr-1"
            />
            <b-button
              v-if="
                order.status === ORDER_STATUS.CONFIRMED &&
                  order.isSelfManagedOrder &&
                  !shipmentOrder &&
                  isBrand
              "
              variant="danger"
              @click="cancelOrderByBrand(false)"
            >
              Cancel order
            </b-button>
            <order-actions
              v-else
              :is-modify-enabled="isModifyEnabled"
              :is-in-draft="isInDraft"
              :order="order"
              :original-order="orderData"
              :total-units="totalUnits"
              :modify-using-import="modifyUsingImport"
              :is-direct-brand="isDirectBrand"
              :load-order="loadOrder"
              :imported-product-statuses="importedProductStatuses"
              :selected-product-ids="partialConfirmProductIds"
              @enable-modify-changes="enableModifyProducts"
              @revert-modified-changes="revertModifiedChanges"
              @update-order="updateOrder"
              @export-order-for-modify="exportOrderForModify"
              @open-import-modal="$bvModal.show('import-order-for-modify')"
              @save-order-success="onSaveOrderSuccess"
            />
          </div>
          <div
            v-if="shipmentOrder && !order.shipmentId"
            class="ml-auto"
          >
            <b-button
              class="mr-1 font-weight-bolder"
              variant="outline-info"
              @click="$emit('cancel-create-shipment')"
            >
              Cancel
            </b-button>
            <b-button
              class="ml-1 font-weight-bolder"
              variant="info"
              :disabled="isShipping"
              @click="$emit('create-shipment')"
            >
              {{ isShipping ? 'Loading...' : 'Create Shipment' }}
            </b-button>
          </div>
        </div>
      </b-row>
      <b-row class="p-0 match-height order-detail">
        <!-- Order log -->
        <b-col lg="4">
          <order-logs :order="order" />
        </b-col>
        <!-- End Order log -->
        <!-- Order info-->
        <b-col lg="4">
          <order-summary
            :order="order"
            @load-order="loadOrder"
          />
        </b-col>
        <!-- End Order info -->
        <!-- Order address -->
        <b-col lg="4">
          <order-addresses :order="order" />
        </b-col>
        <!-- End Order address -->
      </b-row>
      <!-- order products filter -->
      <b-row
        v-if="order.products && order.products.length"
        class="mb-1 order-products-filter"
      >
        <b-col cols="12">
          <order-products-filter
            :order-products="order.products"
            @on-apply-filter="onAppliedFilter"
          />
        </b-col>
      </b-row>
      <!-- order products -->
      <b-row>
        <b-col cols="12">
          <div class="product-checkout mt-0 list-view d-block">
            <b-row>
              <order-products
                :key="reloadkey"
                class="col-md-12"
                :order="order"
                :order-products="
                  isProductsFilterApplied
                    ? filteredOrderProducts
                    : order.products
                "
                :is-shipment="isShipment"
                :is-shipment-settings-modal="!!shipmentOrder"
                :is-modify-enabled="isModifyEnabled"
                :is-filter-applied="isProductsFilterApplied"
                @remove-product="removeOrderProduct"
                @ship-now="$emit('ship-now', $event, orderData.products.length)"
                @reload-order="loadOrder"
                @partial-confirm-selection="partialConfirmProductIds = $event"
              />
            </b-row>
          </div>
        </b-col>
      </b-row>
      <!-- end order products -->
      <b-modal
        id="upload-Order"
        centered
        title="Upload Order"
        hide-footer
      >
        <div>
          <b-form>
            <b-form-group
              label="Upload the Order products file"
              label-for="import-Order"
            >
              <b-form-file
                id="import-Order"
                v-model="orderUploadFile"
                accept=".xlsx"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-form-group>
            <b-button
              class="float-right mt-2 mt-1"
              variant="primary"
              :disabled="uploading"
              @click="syncOrderProducts"
            >
              {{ uploading ? 'Uploading...' : 'Upload' }}
            </b-button>
          </b-form>
        </div>
      </b-modal>
      <b-modal
        id="import-order-for-modify"
        centered
        title="Import Order for Modify"
        hide-footer
      >
        <div>
          <b-form>
            <b-form-group
              label="Upload the modified order file (.xlsx)"
              label-for="import-order-modify"
            >
              <b-form-file
                id="import-order-modify"
                v-model="importForModifyFile"
                accept=".xlsx"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-form-group>
            <b-button
              class="float-right mt-2 mt-1"
              variant="primary"
              :disabled="importingForModify"
              @click="handleImportForModify"
            >
              {{ importingForModify ? 'Importing...' : 'Import' }}
            </b-button>
          </b-form>
        </div>
      </b-modal>
      <b-modal
        v-if="isBrand"
        id="brand-cancel-order"
        ok-variant="danger"
        ok-title="Confirm"
        variant="danger"
        cancel-title="Cancel"
        modal-class="modal-danger"
        centered
        title="Cancel order"
        @ok="cancelOrderByBrand(true)"
      >
        <b-card-text> This order contains shipments. </b-card-text>
        <ul v-if="cancellingShipments">
          <li
            v-for="(item, index) in cancellingShipments"
            :key="index"
          >
            {{ item.shipmentSeqId }} - {{ SHIPMENT_TEXT[item.status] }}
          </li>
        </ul>
        <b-card-text> Proceed with the cancellation? </b-card-text>
      </b-modal>
      <b-modal
        v-if="isBrand"
        id="revert-order-modal"
        ref="revertOrderModal"
        ok-variant="danger"
        ok-title="Confirm"
        cancel-title="Cancel"
        modal-class="modal-danger"
        centered
        title="Revert Order Status"
        @ok="confirmRevertOrder"
      >
        <b-card-text>
          Are you sure you want to revert this order to Order Received?
          This will restore the product quantities back to your inventory.
        </b-card-text>
      </b-modal>
      <b-modal
        id="unsaved-changes-modal"
        ref="unsavedChangesModal"
        ok-variant="danger"
        ok-title="Leave"
        cancel-title="Stay"
        centered
        title="Unsaved Changes"
        @ok="confirmLeave"
        @cancel="cancelLeave"
        @close="cancelLeave"
      >
        <b-card-text>
          Do you really want to leave? Your unsaved changes will be lost.
        </b-card-text>
      </b-modal>
      <!-- modal for download order products -->
      <div>
        <download-modal
          :modal-id="DOWNLOAD_MODAL_ID"
          :options="downloadOption.order"
          :is-downloading="isDownloading"
          @on-click-download="downloadOrderProducts"
        />
      </div>

    </b-container>
    <!-- loading when fetching -->
    <template v-else>
      <b-card class="text-center p-4">
        <b-spinner />
      </b-card>
    </template>
  </div>
</template>

<script>
import { toRef } from '@vue/composition-api'
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BButton,
  BForm,
  BFormGroup,
  BFormFile,
  BSpinner,
  VBModal,
  BCardText,
} from 'bootstrap-vue'
import DownloadModal from '@/@core/components/popup-modal/DownloadModal.vue'
import DownloadCloudIcon from '@/assets/images/icons/download-cloud-icon.svg'
import SplitActionButton from '@/@core/components/split-action-button/SplitActionButton.vue'
import NotificationMixin from '@/views/mixins/NotificationMixin.vue'
import { useOrderDetail } from '@/composables/useOrderDetail'
import OrderProducts from './OrderProducts.vue'
import OrderActions from './OrderActions.vue'
import ShipmentAction from '../shipment/ShipmentAction.vue'
import UserRoleMixinVue from '../UserRoleMixin.vue'
import OrderUploadInvoice from './OrderUploadInvoice.vue'
import OrderLogs from './OrderLogs.vue'
import OrderSummary from './OrderSummary.vue'
import OrderAddresses from './OrderAddresses.vue'
import OrderProductsFilter from './OrderProductsFilter.vue'
import DuplicateOrderButton from './DuplicateOrderButton.vue'

const DOWNLOAD_MODAL_ID = 'download_modal'

export default {
  name: 'OrderDetail',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BButton,
    BForm,
    BFormGroup,
    BFormFile,
    BSpinner,
    OrderProducts,
    DownloadModal,
    SplitActionButton,
    OrderActions,
    ShipmentAction,
    OrderUploadInvoice,
    OrderLogs,
    OrderSummary,
    OrderAddresses,
    OrderProductsFilter,
    DuplicateOrderButton,
    BCardText,
  },
  directives: {
    'b-modal': VBModal,
  },
  mixins: [UserRoleMixinVue, NotificationMixin],
  props: {
    shipmentOrder: {
      type: Object,
      default() {
        return null
      },
    },
    isShipping: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  emits: [
    'ship-now',
    'cancel-create-shipment',
    'create-shipment',
    'load-shipment',
    'open-import-export',
  ],
  setup(props) {
    const shipmentOrderRef = toRef(props, 'shipmentOrder')
    const d = useOrderDetail(shipmentOrderRef)
    return {
      // State
      isLoaded: d.isLoaded,
      order: d.order,
      orderData: d.orderData,
      totalUnits: d.totalUnits,
      total: d.total,
      isDownloading: d.isDownloading,
      isModifyEnabled: d.isModifyEnabled,
      isInDraft: d.isInDraft,
      modifyUsingImport: d.modifyUsingImport,
      reloadkey: d.reloadkey,
      filteredOrderProducts: d.filteredOrderProducts,
      isProductsFilterApplied: d.isProductsFilterApplied,
      cancelledProductIds: d.cancelledProductIds,
      isRevertingOrder: d.isRevertingOrder,
      importedProductStatuses: d.importedProductStatuses,
      uploading: d.uploading,
      orderUploadFile: d.orderUploadFile,
      importForModifyFile: d.importForModifyFile,
      importingForModify: d.importingForModify,
      downloadOption: d.downloadOption,
      cancellingShipments: d.cancellingShipments,
      // Computeds
      hasDuplicateOrderFeature: d.hasDuplicateOrderFeature,
      orderId: d.orderId,
      hasOrderConfirmed: d.hasOrderConfirmed,
      canShowDownloadOrderInvoiceBtn: d.canShowDownloadOrderInvoiceBtn,
      isSelfManagedOrder: d.isSelfManagedOrder,
      canShowDownloadOrderButton: d.canShowDownloadOrderButton,
      isShipment: d.isShipment,
      isDirectBrand: d.isDirectBrand,
      canShowBackToReceivedButton: d.canShowBackToReceivedButton,
      // Constants
      ORDER_STATUS: d.ORDER_STATUS,
      SHIPMENT_TEXT: d.SHIPMENT_TEXT,
      formatNumber: d.formatNumber,
      formattedDate: d.formattedDate,
      formatCurrency: d.formatCurrency,
      KP_DATE_FORMAT: d.KP_DATE_FORMAT,
      DownloadCloudIcon,
      DOWNLOAD_MODAL_ID,
      // Methods used directly (no wrapping needed)
      onAppliedFilter: d.onAppliedFilter,
      enableModifyProducts: d.enableModifyProducts,
      exportOrderForModify: d.exportOrderForModify,
      // Methods needing wrapping (prefixed)
      _loadOrder: d.loadOrder,
      _initDownloadOptions: d.initDownloadOptions,
      _updateOrder: d.updateOrder,
      _removeOrderProduct: d.removeOrderProduct,
      _revertModifiedChanges: d.revertModifiedChanges,
      _downloadOrderProducts: d.downloadOrderProducts,
      _syncOrderProducts: d.syncOrderProducts,
      _handleImportForModify: d.handleImportForModify,
      _cancelOrderByBrand: d.cancelOrderByBrand,
      _handleRevertToAccepted: d.handleRevertToAccepted,
      _revertOrderToAccepted: d.revertOrderToAccepted,
    }
  },
  data() {
    return {
      pendingRoute: null,
      removeRouterGuard: null,
      isNavigationConfirmed: false,
      // KP-4363: products ticked for partial confirmation
      partialConfirmProductIds: [],
    }
  },
  watch: {
    modifyUsingImport(val) {
      if (val) {
        window.addEventListener('beforeunload', this.handleBeforeUnload)
      } else if (!this.isModifyEnabled) {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
      }
    },
    isModifyEnabled(val) {
      if (val) {
        window.addEventListener('beforeunload', this.handleBeforeUnload)
      } else if (!this.modifyUsingImport) {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
      }
    },
    cancellingShipments(newVal) {
      if (newVal && newVal.length) {
        this.$bvModal.show('brand-cancel-order')
      }
    },
  },
  async mounted() {
    this.removeRouterGuard = this.$router.beforeEach((to, from, next) => {
      const hasUnsavedChanges = (this.modifyUsingImport || this.isModifyEnabled) && !this.isNavigationConfirmed
      if (hasUnsavedChanges) {
        this.pendingRoute = to
        this.$bvModal.show('unsaved-changes-modal')
        next(false)
      } else {
        this.isNavigationConfirmed = false
        next()
      }
    })
    await this.loadOrder()
    this._initDownloadOptions()
  },
  beforeDestroy() {
    if (this.removeRouterGuard) {
      this.removeRouterGuard()
    }
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  },
  methods: {
    // KP-4363: rebuilt on open, so confirmation stages added since the page
    // loaded are listed
    openDownloadModal() {
      this._initDownloadOptions()
      this.$bvModal.show(DOWNLOAD_MODAL_ID)
    },
    handleBeforeUnload(e) {
      e.preventDefault()
      e.returnValue = ''
    },
    confirmLeave() {
      this.isNavigationConfirmed = true
      this.$router.push(this.pendingRoute)
    },
    cancelLeave() {
      this.pendingRoute = null
    },
    async loadOrder() {
      await this._loadOrder(this.$route.params.orderId)
      this.updateBreadcrumb()
      this.showExpectedAvailabilityDatePopup()
    },
    getDynamicOrderName() {
      return this.order.shipmentId
        ? this.orderData.shipmentSeqId
        : this.orderData.orderSeqId
    },
    updateBreadcrumb() {
      if (!this.order || !this.$route.meta.breadcrumb) return
      const orderName = this.getDynamicOrderName()
      this.$route.meta.breadcrumb = this.$route.meta.breadcrumb.map(item => {
        if (item.dynamic === true) {
          item.orderName = orderName
        }
        return item
      })
    },
    shouldShowExpAvDatePopup() {
      if (!this.orderData) return false
      return this.orderData.shouldDisplayExpectedAvailabilityDatePopup
        && this.orderData.expectedAvailabilityDate == null
        && !this.isDirectBrand
    },
    showExpectedAvailabilityDatePopup() {
      if (!this.shouldShowExpAvDatePopup()) return
      setTimeout(() => this.$bvModal.show('modal-exp-av-date'), 1000)
    },
    isExAvDateUnavailable(err) {
      const data = err.response?.data?.data
      return this.isBrand
        && data?.hasOwnProperty('isAvailableExAvDate')
        && !data.isAvailableExAvDate
    },
    validateExAvDate(err) {
      if (this.isExAvDateUnavailable(err)) {
        this.$bvModal.show('modal-exp-av-date')
      }
    },
    handleUpdateOrderResult(result) {
      if (result?.success) {
        this.loadOrder()
        return
      }
      if (result?.err) {
        this.validateExAvDate(result.err)
      }
    },
    updateOrder(shouldConfirmOrder = false) {
      this._updateOrder(shouldConfirmOrder).then(result => {
        this.handleUpdateOrderResult(result)
      })
    },
    removeOrderProduct(product, index) {
      this._removeOrderProduct(product, index, this.$route.params.orderId)
    },
    revertModifiedChanges() {
      this._revertModifiedChanges(this.$route.params.orderId)
    },
    downloadOrderProducts(downloadType) {
      this._downloadOrderProducts(downloadType)
      const unwatch = this.$watch('isDownloading', val => {
        if (!val) {
          this.$bvModal.hide(DOWNLOAD_MODAL_ID)
          unwatch()
        }
      })
    },
    async syncOrderProducts() {
      const result = await this._syncOrderProducts()
      if (result?.success) {
        this.$bvModal.hide('upload-Order')
      }
    },
    onSaveOrderSuccess() {
      this.order = null
      this.modifyUsingImport = false
      this.isModifyEnabled = false
      this.isInDraft = false
      this.importedProductStatuses = []
      this.cancelledProductIds = []
    },
    async handleImportForModify() {
      const result = await this._handleImportForModify()
      if (result?.success) {
        this.$bvModal.hide('import-order-for-modify')
      }
    },
    cancelOrderByBrand(isConfirmed = false) {
      this._cancelOrderByBrand(isConfirmed, this.$route.params.orderId)
    },
    async handleRevertToAccepted() {
      const result = await this._handleRevertToAccepted(this.$route.params.orderId)
      if (result?.showRevertModal) {
        this.$bvModal.show('revert-order-modal')
      }
    },
    async confirmRevertOrder() {
      await this._revertOrderToAccepted(this.$route.params.orderId)
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~@core/scss/base/pages/app-order-detail.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.order-products-filter {
  position: sticky;
  top: $nav-bar-height;
  z-index: 50;
  background-color: $body-bg;
}
</style>
